import { createSlice } from "@reduxjs/toolkit";
import {userApi} from "../api/userApi";
import sharedDataApi from "../api/sharedDataApi";

export const appSlice = createSlice({
  name: "app",
  initialState: {
    isLoading: false,
    toast: {
      isOpen: false,
    },
    user: {
      name: null,
      email: null,
      roles: [],
    },
  },
  reducers: {
    setLoading: (state, action) => {
      const { payload } = action;
      state.isLoading = payload.isLoading;
    },
    setToast: (state, action) => {
      const { payload } = action;
      state.toast = payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const createUserIfNew = (payload) =>  async (dispatch, getState) => {
  const { name, email, roles } = {...payload};
  const roleString = JSON.stringify(roles);
  const emailLower = email.trim().toLowerCase();
  try {
    const existingUser = await userApi.getUser({user: {Email: email}});
    if (!existingUser) {
      try {
        await userApi.createUser({user: { Name: name, Email: email, Role: roleString }})
        //Create SES identity for the new user
        try {
          await sharedDataApi.manageEmailSesIdentity({
            identity: emailLower,
            action: "CREATE",
          });
          console.log("SES identity created successfully for: " + emailLower);
        } catch (sesError) {
          console.log("Cannot create SES identity for " + emailLower + " error: " + sesError);
        }
      } catch (e) {
        console.log("cannot create user" + { name, email, roles } + " error: " + e)
      }
      } else {
      // Existing user - update role if changed from azureAD
      if (existingUser.Role !== roleString) {
        try {
          await userApi.updateUser({
            user: { Email: email, Role: roleString }
          });
          console.log("User role updated for: " + email);
        } catch (e) {
          console.log("Cannot update user role for " + email + " error: " + e);
        }
      }
    }
  } catch (e) {
    console.log("cannot fetch user with email" + email + " error: " + e)
  }
}

export const { setLoading, setToast, setUser } = appSlice.actions;
export const selectLoading = (state) => state.app.isLoading;
export const selectToast = (state) => state.app.toast;
export const selectUser = (state) => state.app.user;
export default appSlice.reducer;
